import { render, staticRenderFns } from "./QuestionApplicationSection.vue?vue&type=template&id=e2fbb490&scoped=true&"
import script from "./QuestionApplicationSection.vue?vue&type=script&lang=js&"
export * from "./QuestionApplicationSection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionApplicationSection.vue?vue&type=style&index=0&id=e2fbb490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fbb490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
